import React, {
  createContext,
  useState,
  Dispatch,
  SetStateAction,
  JSX,
} from 'react';
import { IPTCDocument } from '../../models/order-details/ptc-documents';

export interface IPTCDocumentsContext {
  openPTCDocumentDrawer: boolean;
  setOpenPTCDocumentDrawer: Dispatch<SetStateAction<boolean>>;
  selectedDocument: IPTCDocument | undefined;
  setSelectedDocument: Dispatch<SetStateAction<IPTCDocument | undefined>>;
  handleCloseDrawer: () => void;
  documentLoadingError: boolean;
  setDocumentLoadingError: Dispatch<SetStateAction<boolean>>;
}

interface IPTCDocumentsProvider {
  children: JSX.Element;
}

export const PTCDocumentsContext = createContext<IPTCDocumentsContext>({
  openPTCDocumentDrawer: false,
  setOpenPTCDocumentDrawer: () => false,
  selectedDocument: undefined,
  setSelectedDocument: () => undefined,
  handleCloseDrawer: () => undefined,
  documentLoadingError: false,
  setDocumentLoadingError: () => undefined,
});

export const PTCDocumentsProvider = ({ children }: IPTCDocumentsProvider) => {
  const [openPTCDocumentDrawer, setOpenPTCDocumentDrawer] =
    useState<boolean>(false);
  const [selectedDocument, setSelectedDocument] = useState<
    IPTCDocument | undefined
  >(undefined);
  const [documentLoadingError, setDocumentLoadingError] =
    useState<boolean>(false);

  // Function to handle closing the drawer and clearing the selected document
  const handleCloseDrawer = () => {
    // Closing the drawer first
    setOpenPTCDocumentDrawer(false);

    // Clear the selected document after a short delay to not have a flicker in the UI
    // when the drawer closes
    setTimeout(() => {
      setSelectedDocument(undefined);
      setDocumentLoadingError(false);
    }, 400);
  };

  return (
    <PTCDocumentsContext.Provider
      value={{
        openPTCDocumentDrawer,
        setOpenPTCDocumentDrawer,
        selectedDocument,
        setSelectedDocument,
        handleCloseDrawer,
        documentLoadingError,
        setDocumentLoadingError,
      }}
    >
      {children}
    </PTCDocumentsContext.Provider>
  );
};

export default PTCDocumentsProvider;
